document.addEventListener('DOMContentLoaded', function () {
  const sliderContainers = document.querySelectorAll('.product-3-slider');

  class Carousel {
    constructor(container, infoContainer, nextButton, prevButton) {
      this.carouselContainer = container;
      this.infoContainer = infoContainer;
      this.sliderItems = container.querySelectorAll('.slide-item');
      this.sliderNextButton = nextButton;
      this.prevButton = prevButton;
      this.carouselArray = [...this.sliderItems];
      this.currentDirection = ''; // To keep track of the direction
      this.initSlideClasses(); // Initialize slide number classes
      this.setControls();
      this.updateSlider(); // Initialize the gallery
    }

    initSlideClasses() {
      this.carouselArray.forEach((el, i) => {
        if (i < 3) {
          el.classList.add(`slide-item-${i + 1}`);
        }
      });
    }

    updateSlider() {
      this.carouselArray.forEach((el, i) => {
        el.classList.remove('slide-item-1', 'slide-item-2', 'slide-item-3', 'active');
        if (i < 3) {
          el.classList.add(`slide-item-${i + 1}`);
        }
        if (i === 1) {
          // Add active class to the second gallery item
          el.classList.add('active');
        }
      });
      this.updateSliderInfo(); // Update the current slide info
    }

    updateSliderInfo() {
      const totalSlides = this.carouselArray.length;
      const activeSlideIndex =
        Array.from(this.carouselContainer.querySelectorAll('.slide-item')).findIndex((item) =>
          item.classList.contains('active')
        ) + 1;
      this.infoContainer.textContent = `${activeSlideIndex} of ${totalSlides}`;
    }

    setCurrentState(direction) {
      this.carouselContainer.classList.remove('next', 'prev');

      if (direction === this.prevButton) {
        this.carouselArray.unshift(this.carouselArray.pop());
        this.currentDirection = 'prev';
        this.carouselContainer.classList.add('prev');
      } else {
        this.carouselArray.push(this.carouselArray.shift());
        this.currentDirection = 'next';
        this.carouselContainer.classList.add('next');
      }

      this.updateSlider();
    }

    setControls() {
      this.prevButton.addEventListener('click', (e) => {
        e.preventDefault();
        this.setCurrentState(this.prevButton);
      });

      this.sliderNextButton.addEventListener('click', (e) => {
        e.preventDefault();
        this.setCurrentState(this.sliderNextButton);
      });
    }
  }

  sliderContainers.forEach(sliderContainer => {
    const sliderInfoContainer = sliderContainer.querySelector('.slider-counter'); 
    const sliderNextButton = sliderContainer.querySelector('.controls-next');
    const prevButton = sliderContainer.querySelector('.controls-prev');
    const sliderItems = sliderContainer.querySelectorAll('.slide-item');

    if (sliderItems.length > 0) {
      new Carousel(sliderContainer, sliderInfoContainer, sliderNextButton, prevButton);
    }
  });
});
